import getWithToken from './base/get-with-token'

const getRoleName = getWithToken(`/get-role-name`)

export default getRoleName
